import { ITripsTableSchema } from './trip-table-schema.interface';

export interface ITripHistoricSchema extends ITripsTableSchema {
    originalId: string;
}
